import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=37a007ef&scoped=true&"
import script from "./FileLoader.vue?vue&type=script&lang=ts&"
export * from "./FileLoader.vue?vue&type=script&lang=ts&"
import style0 from "./FileLoader.vue?vue&type=style&index=0&id=37a007ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a007ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VFileInput,VIcon,VProgressCircular,VRow,VTextField,VTooltip})
